import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMapPin, FiPhone, FiMail } = FiIcons;

export default function Contact() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="py-20 bg-[#faf9f6] min-h-screen"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-serif text-gray-900 mb-4">Contact Us</h1>
          <div className="w-16 h-1 bg-[#d4af37] mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          
          {/* Contact Info */}
          <div className="bg-white p-10 shadow-sm border border-gray-100">
            <h3 className="text-2xl font-serif mb-8 text-gray-900">Get in Touch</h3>
            
            <div className="space-y-8">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-[#faf9f6] rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                  <SafeIcon icon={FiMapPin} className="w-5 h-5 text-[#d4af37]" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 text-lg mb-1">Address</h4>
                  <p className="text-gray-600 leading-relaxed">
                    9 Ganesham, Ajmer Road<br />
                    Shyam Nagar No. 2, Behind Sodhani Sweets<br />
                    Sodala, Jaipur
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-[#faf9f6] rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                  <SafeIcon icon={FiPhone} className="w-5 h-5 text-[#d4af37]" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 text-lg mb-1">Call / WhatsApp</h4>
                  <p className="text-gray-600">+91 91191 23305</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0 bg-[#d4af37]/10 p-3 rounded-lg">
                  <FiMail className="w-6 h-6 text-[#d4af37]" />
                </div>
                <div className="ml-4">
                  <h4 className="text-lg font-medium text-gray-900">Email Us</h4>
                  <p className="mt-1 text-gray-600">Our team is here to help.</p>
                  <a href="mailto:hello@tatvamretail.in" className="text-[#d4af37] hover:underline font-medium mt-1 inline-block">
                    hello@tatvamretail.in
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Map updated to point close to Sodala/Sodhani Sweets */}
          <div className="h-[500px] w-full bg-gray-200 rounded-sm overflow-hidden shadow-sm">
            <iframe 
              src="https://maps.google.com/maps?q=Sodhani%20Sweets,%20Sodala,%20Jaipur&t=&z=15&ie=UTF8&iwloc=&output=embed" 
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Tatvam Location"
            ></iframe>
          </div>

        </div>
      </div>
    </motion.div>
  );
}